import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { AuthShell } from "@/features/auth/AuthShell";
import { authService } from "@/services/authService";
import { apiError } from "@/services/api";
import { Button, Input, Label } from "@/components";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("forgotPassword.title")} subtitle={t("forgotPassword.subtitle")}>
      {sent ? (
        <div className="flex flex-col gap-4 text-center" data-testid="forgot-sent">
          <p className="text-sm">{t("forgotPassword.sent", { email })}</p>
          <Button asChild variant="outline"><Link to="/login">{t("forgotPassword.backToLogin")}</Link></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-4" data-testid="forgot-form">
          <div className="flex flex-col gap-2">
            <Label htmlFor="email">{t("forgotPassword.email")}</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder={t("forgotPassword.emailPlaceholder")} required data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit">
            {loading ? t("forgotPassword.submitting") : t("forgotPassword.submit")}
          </Button>
          <p className="text-center text-sm text-muted-foreground">
            <Link to="/login" className="text-primary hover:underline">{t("forgotPassword.backToLogin")}</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
